<template>
    <div>
        <action-bar>
            <router-link to="/online-factor-customer-create" class="btn btn-success">{{ $t('online-factor.label_create_customer') }}</router-link>
        </action-bar>
        <online-factor-filter :action="filterAction"></online-factor-filter>
        <customers-with-manage 
            v-if="$can('read', 'payment-link')" 
            :query="query"
            @filter="filterAction"
        ></customers-with-manage>
        <customers-without-manage 
            v-else 
            :query="query"
            @filter="filterAction"
        ></customers-without-manage>
    </div>
</template>

<script>
import Filter from './components/filter_customer'
import actionBar from '@/components/custom/action-bar'
import CustomersWithManage from './CustomersWithManageAccess.vue'
import CustomersWithoutManage from './CustomersWithoutManageAccess.vue'

export default {
    name: 'customers',
    components:{
        'online-factor-filter': Filter,
        'action-bar': actionBar,
        'customers-with-manage': CustomersWithManage,
        'customers-without-manage': CustomersWithoutManage
    },
    data() {
        return {
            query: {}
        };
    },
    methods: {
        filterAction(e, query) {
            this.query = query;
            this.$emit('filter', e, query);
        }
    },
}
</script>